import type { FC } from 'react';
import CtaBand from './cta-band';
import TrustBar from './trust-bar';
import { usePathname } from '../../lib/use-pathname';

type PreFooterProps = {
  onInquire: () => void;
};

const HIDDEN_PATHS = ['/thank-you/'];

const PreFooter: FC<PreFooterProps> = ({ onInquire }) => {
  const pathname = usePathname();

  if (HIDDEN_PATHS.includes(pathname)) {
    return null;
  }

  return (
    <section aria-label="Trust and contact" className="pre-footer">
      <TrustBar />
      <CtaBand onInquire={onInquire} />
    </section>
  );
};

export default PreFooter;
